// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__Kefx6","item":"PaymentsMobile_item__3WSwJ","label":"PaymentsMobile_label__3pELg","amount":"PaymentsMobile_amount__1v7jv"};